function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.28685 11.0336C7.28685 10.783 7.08363 10.5801 6.83289 10.5801H5.24875C4.9983 10.5801 4.79504 10.783 4.79504 11.0336V12.6175C4.79504 12.8684 4.9983 13.0714 5.24875 13.0714H6.83289C7.08363 13.0714 7.28685 12.8684 7.28685 12.6175V11.0336Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2457 11.0336C11.2457 10.783 11.0424 10.5801 10.7922 10.5801H9.20786C8.95741 10.5801 8.75415 10.783 8.75415 11.0336V12.6175C8.75415 12.8684 8.95741 13.0714 9.20786 13.0714H10.7922C11.0424 13.0714 11.2457 12.8684 11.2457 12.6175V11.0336Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2049 11.0336C15.2049 10.783 15.0017 10.5801 14.7512 10.5801H13.1671C12.9163 10.5801 12.7131 10.783 12.7131 11.0336V12.6175C12.7131 12.8684 12.9163 13.0714 13.1671 13.0714H14.7512C15.0017 13.0714 15.2049 12.8684 15.2049 12.6175V11.0336Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.28685 14.9928C7.28685 14.7419 7.08363 14.5391 6.83289 14.5391H5.24875C4.9983 14.5391 4.79504 14.7419 4.79504 14.9928V16.5765C4.79504 16.8272 4.9983 17.0302 5.24875 17.0302H6.83289C7.08363 17.0302 7.28685 16.8271 7.28685 16.5765V14.9928Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2457 14.9928C11.2457 14.7419 11.0424 14.5391 10.7922 14.5391H9.20786C8.95741 14.5391 8.75415 14.7419 8.75415 14.9928V16.5765C8.75415 16.8272 8.95741 17.0302 9.20786 17.0302H10.7922C11.0424 17.0302 11.2457 16.8271 11.2457 16.5765V14.9928Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2049 14.9928C15.2049 14.7419 15.0017 14.5391 14.7514 14.5391H13.1671C12.9163 14.5391 12.7131 14.7419 12.7131 14.9928V16.5765C12.7131 16.8272 12.9163 17.0302 13.1671 17.0302H14.7514C15.0017 17.0302 15.2049 16.8271 15.2049 16.5765V14.9928Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0376 2.22646V4.64579C18.0376 5.73931 17.1505 6.62051 16.0571 6.62051H14.8078C13.7144 6.62051 12.8155 5.73931 12.8155 4.64579V2.21777H7.18447V4.64579C7.18447 5.73931 6.28565 6.62051 5.19238 6.62051H3.94282C2.84951 6.62051 1.96245 5.73931 1.96245 4.64579V2.22646C1.00689 2.25526 0.22168 3.04596 0.22168 4.01783V18.1963C0.22168 19.1864 1.02422 19.9996 2.01436 19.9996H17.9856C18.9743 19.9996 19.7783 19.1847 19.7783 18.1963V4.01783C19.7783 3.04596 18.9931 2.25526 18.0376 2.22646ZM17.4573 17.3133C17.4573 17.7412 17.1103 18.0884 16.6823 18.0884H3.28355C2.85549 18.0884 2.50855 17.7412 2.50855 17.3133V9.98967C2.50855 9.5616 2.85545 9.21446 3.28355 9.21446H16.6822C17.1103 9.21446 17.4573 9.5616 17.4573 9.98967L17.4573 17.3133Z",
  fill: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M3.93849 5.32396H5.17425C5.54934 5.32396 5.85347 5.02028 5.85347 4.64519V0.67901C5.85347 0.303881 5.54934 0 5.17425 0H3.93849C3.56336 0 3.25928 0.303881 3.25928 0.67901V4.64519C3.25928 5.02028 3.56336 5.32396 3.93849 5.32396Z",
  fill: "currentColor"
});

var _ref0 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7918 5.32396H16.0276C16.4024 5.32396 16.7066 5.02028 16.7066 4.64519V0.67901C16.7066 0.303881 16.4025 0 16.0276 0H14.7918C14.4168 0 14.1127 0.303881 14.1127 0.67901V4.64519C14.1127 5.02028 14.4168 5.32396 14.7918 5.32396Z",
  fill: "currentColor"
});

function SvgDatePicker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePicker);
export default __webpack_public_path__ + "static/media/date-picker.461ce202.svg";
export { ForwardRef as ReactComponent };